// The Prices calendar's views as the address names them. No imports: `routes.ts` reads it, and the drafts modules stay out of its chunk.

/** The views in the switcher's order; `calendarViews.test.ts` holds it to `CALENDAR_VIEW_MODES`. */
export const CALENDAR_VIEW_KEYS = [
    "reservations",
    "minStay",
    "delta",
    "occupancy",
    "demand",
    "market",
    "compset",
] as const;

export type CalendarViewKey = (typeof CALENDAR_VIEW_KEYS)[number];

/** The views offered only while the property tracks its competitors. */
export const MARKET_VIEW_KEYS = ["market", "compset"] as const satisfies readonly CalendarViewKey[];

/** The views offered with tracking on or off, in switcher order. */
export function calendarViewKeysFor(tracking: boolean): CalendarViewKey[] {
    if (tracking) return [...CALENDAR_VIEW_KEYS];
    const market: readonly CalendarViewKey[] = MARKET_VIEW_KEYS;
    return CALENDAR_VIEW_KEYS.filter((key) => !market.includes(key));
}

/** How `?view=` spells each view. `reservations` is what links already sent carry, so it never changes. */
export const CALENDAR_VIEW_SLUGS: Readonly<Record<CalendarViewKey, string>> = {
    reservations: "reservations",
    minStay: "min-stay",
    delta: "price-change",
    occupancy: "occupancy",
    demand: "demand",
    market: "market-pressure",
    compset: "market-rates",
};

const VIEW_BY_SLUG = new Map<string, CalendarViewKey>(
    CALENDAR_VIEW_KEYS.map((key) => [CALENDAR_VIEW_SLUGS[key], key]),
);

/** The view a slug names exactly as written, or null; the caller lowercases what the address carries. */
export function calendarViewFromSlug(slug: string | null | undefined): CalendarViewKey | null {
    return slug ? VIEW_BY_SLUG.get(slug) ?? null : null;
}
